import {getEcCom} from '../util/convert';
import {getHostURLencode} from "../../workflowForm/util/secondAuthUtil";

const {WeaTools} = getEcCom();

//获取二次验证的配置信息
export const getSecondAuthConfig = (params) => {
    Object.assign(params, {"__weaver_request_url__":getHostURLencode()})
    return WeaTools.callApi('/api/workflow/secondauth/getSecondAuthConfig', 'POST', params);
}

//获取动态密码
export const getDynamicPassword = params => {
    return WeaTools.callApi('/api/workflow/secondauth/getDynamicPassword', 'POST', params);
}

//二次验证，主要是二次密码，动态令牌，动态密码的验证
export const doSecondAuth = params => {
    return WeaTools.callApi('/api/workflow/secondauth/doSecondAuth', 'POST', params);
}

//发送CA认证的消息
export const sendCAMessage = params => {
    return WeaTools.callApi('/api/workflow/secondauth/sendCAMessage', 'POST', params);
}

//验证CA认证
export const checkCAAuth = params => {
    return WeaTools.callApi('/api/workflow/secondauth/checkCAAuth', 'POST', params);
}

//保存CA认证的结果
export const saveCAAuthResult = params => {
    return WeaTools.callApi('/api/workflow/secondauth/saveCAAuthResult', 'POST', params);
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflowForm/apis/secondAuth.js